import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '@/components/dashboard/shared/PageHeader';
import { KpiCard } from '@/components/dashboard/shared/KpiCard';
import { KpiGrid } from '@/components/dashboard/shared/KpiGrid';
import { CustomerList } from '@/components/dashboard/customers/CustomerList';
import { DashboardHead } from '@/components/SEO/DashboardHead';
import api from '@/utils/api';
import { useCurrentStore } from '@/hooks/useCurrentStore';
import {
  RiGroupLine,
  RiUserAddLine,
  RiUserHeartLine,
  RiMoneyDollarCircleLine,
} from '@remixicon/react';

type CustomerStats = {
  totalCustomers: number;
  newThisMonth: number;
  activeCustomers: number;
  avgCustomerValue: number;
};

export function CustomersPage() {
  const { storeId, currentStore } = useCurrentStore();

  const { data: stats, isLoading } = useQuery<CustomerStats>({
    queryKey: ['customer-stats', storeId],
    queryFn: async () => {
      const { data } = await api.get('/api/customers/stats');
      return data;
    },
    enabled: !!storeId,
  });

  return (
    <div className="space-y-6">
      <DashboardHead pageName="Customers" />
      <PageHeader title="Customers" subtitle="See who shops with you and how they engage." />

      <KpiGrid loading={isLoading} skeletonCount={4}>
        <KpiCard
          label="Total Customers"
          value={stats?.totalCustomers ?? 0}
          icon={<RiGroupLine />}
        />
        <KpiCard
          label="New This Month"
          value={stats?.newThisMonth ?? 0}
          icon={<RiUserAddLine />}
        />
        <KpiCard
          label="Active (30 days)"
          value={stats?.activeCustomers ?? 0}
          icon={<RiUserHeartLine />}
        />
        <KpiCard
          label="Avg. Customer Value"
          value={stats?.avgCustomerValue ?? 0}
          currency={currentStore?.currency || 'NGN'}
          icon={<RiMoneyDollarCircleLine />}
        />
      </KpiGrid>

      <CustomerList searchTerm="" statusFilter="all" />
    </div>
  );
}
